/**
 * Constants for formatting date and time
 */
export class DateTimeFormats {
  public static SIMPLE_DATE = 'MMM DD, YYYY';
  public static TIME_AM_PM = 'hh:mm A';
  public static GENERAL_DATE_FORMAT = 'MM/DD/YYYY';
  public static INPUT_FORMAT = 'yyyy-MM-dd';
  public static BASIC = 'MM/dd/yyyy';
  public static BASIC_WITH_TIME = 'MM/dd/yyyy hh:mm a';
}
